module.exports = __webpack_public_path__ + "static/epidemic-543248eea98f59d4a14736f5d2271fbf.gif";